/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { MYCUSTOMERS, MYBROKERS, MYPROJECTS, DRMBROKERS, GETRM, UPDATERMLIVEDETAILS, RMLIVEDETAILS, UPDATERMBROKER, UPDATERMCUSTOMER, UPDATERMPROJECT } from './mutation-types';

export default {
  [MYCUSTOMERS](state, payload) {
    state.myCustomers = payload;
  },

  [MYBROKERS](state, payload) {
    state.myBrokers = payload;
  },

  [MYPROJECTS](state, payload) {
    state.myProjects = payload;
  },
  [DRMBROKERS](state, payload) {
    state.drmBrokers = payload;
  },
  [GETRM](state, payload) {
    // const emptyRM = {
    //   fullName: 'None',
    //   id: '',
    // };
    payload.forEach((element) => {
      element.fullName = `${element.first_name} ${element.last_name}`;
    });
    // state.internalRMs.push(emptyRM);
    state.internalRMs = payload;
  },
  [RMLIVEDETAILS](state, payload) {
    state.rmLive = payload;
  },

  [UPDATERMLIVEDETAILS](state, payload) {
    if (`${state.rmLive.auction_id}` === `${payload.auction_id}`)
      state.rmLive = payload;
  },

  [UPDATERMBROKER](state, payload) {
    state.myBrokers = payload;
  },

  [UPDATERMCUSTOMER](state, payload) {
    state.myCustomers = payload;
  },

  [UPDATERMPROJECT](state, payload) {
    state.myProjects = payload;
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/rm/mutations.js